import { styled, alpha } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';

export const LoadingRoot = styled('div', {
  shouldForwardProp: prop => prop !== 'fadeOut',
})(({ theme, fadeOut }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  backgroundColor: theme.palette.primary.main,
  ...(fadeOut === undefined
    ? {
        height: '100vh',
      }
    : {
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100%',
        zIndex: theme.zIndex.modal,
        opacity: fadeOut ? 0 : 1,
        transition: 'opacity 400ms ease-out',
        pointerEvents: fadeOut ? 'none' : 'auto',
      }),
}));

export const LoadingContent = styled('div')({
  width: '80%',
  maxWidth: 400,
  textAlign: 'center',
});

export const LoadingMessage = styled('p')(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: 24,
  fontWeight: 400,
  color: theme.palette.common.white,
  margin: theme.spacing(0, 0, 3),
  letterSpacing: '0.5px',
}));

export const ProgressBar = styled(LinearProgress)(({ theme }) => ({
  borderRadius: 2,
  height: 4,
  backgroundColor: alpha(theme.palette.common.white, 0.2),
  '& .MuiLinearProgress-bar': {
    backgroundColor: theme.palette.common.white,
    borderRadius: 2,
  },
}));
